<template>
	<lv-base-column
		ref="column" v-bind="columnBinding">

		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
			<link-table-column-select-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"
				@click="lv_clickItem"

				:disabled-hide-on-click-outside="disabledHideOnClickOutside"
				:data="data"
				:val-key="valKey"
				:label-key="labelKey"
				:multiple="multiple"
				:data-func="dataFunc"
				:beforeSelect="beforeSelect"
				:afterSelect="afterSelect"

				@select="$emit('select',$event)"
			/>
		</template>
	</lv-base-column>
</template>

<script>

	import {ColumnMixin} from "../mixins";
	import LinkTableColumnSelectItem from "./link-table-column-select-item";
	import LvBaseColumn from "../../table/lv-base-column";

	export default {
		name: "link-table-column-select",
		components: {LinkTableColumnSelectItem, LvBaseColumn},
		mixins: [ColumnMixin],
		props: {
			width: {default: 100},

			data: {type: Array},
			valKey: {type: String, default: 'val'},
			labelKey: {type: String, default: 'name'},
			dataFunc: {type: Function,},
			beforeSelect: {type: Function},
			afterSelect: {type: Function},
			multiple: {type: Boolean, default: false},
			disabledHideOnClickOutside: {type: Boolean, default: false},    // 禁用点击外部的时候关闭弹出框

			formatter: {
				default() {
					return async (val, data) => {
						const selectData = !!this.dataFunc ? await this.dataFunc(data.showRow, data.rowIndex) : this.data
						if (!selectData || selectData.length === 0 || val == null) return null
						switch (this.$lv.$utils.typeOf(val)) {
							case 'array':
								return selectData.reduce((ret, item) => {
									val.indexOf(item[this.valKey]) > -1 && ret.push(item[this.labelKey])
									return ret
								}, []).join(',')
							case 'string':
								return selectData.reduce((ret, item) => item[this.valKey] === val ? item[this.labelKey] : ret, '')
							default :
								return null
						}
					}
				},
			},

			translate: {
				default() {
					return (val) => {
						if (!this.data) throw new Error('动态下拉列暂不支持列筛选功能！')
						if (this.$lv.$utils.typeOf(val) === 'array') throw new Error('多选下拉列暂不支持列筛选功能！')

						return this.data.reduce((ret, item) => item[this.valKey] === val ? item[this.labelKey] : ret, '')
					}
				},
			},
			getFiltersRawBySortFilterText: {
				default() {
					return async (filterText) => {

						if (!this.data) throw new Error('动态下拉列暂不支持列筛选功能！')
						if (this.$lv.$utils.typeOf(val) === 'array') throw new Error('多选下拉列暂不支持列筛选功能！')

						let vals = this.data.filter(item => item[this.labelKey].indexOf(filterText) > -1).map(item => item[this.labelKey])

						if (vals.length === 0) {
							vals = ['noMachFilterText']
						}
						return {
							value: `[${vals.join(',')}]`,
							operator: 'in',
						}
					}
				},
			},
		},
		watch: {
			data() {
				const table = this.$lv.$dom.findComponentUpward(this, 'lv-base-table')
				const cellNormals = this.$lv.$dom.findComponentsDownward(table, (com) => com.$options.name === 'lv-table-cell-normal' && com.data.col.field === this.field && !com.head)
				// console.log(cellNormals)
				cellNormals.forEach(item => item.reCalc())
			},
		},
	}
</script>
